module.exports = __webpack_public_path__ + "static/1-7208c7c3b5a08f02df6da5e7114d0945.jpeg";